<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { ref, computed } from 'vue'
import RoleTag from './RoleTag.vue'
import RolePicker from './RolePicker.vue'
import { useFormDisabled, useFormSize } from 'element-plus'

const $props = defineProps({
  modelValue: {
    type: [String, Array],
    default: undefined
  },
  multiple: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: '请选择角色'
  }
})
const $emits = defineEmits(['update:modelValue'])
const valueArr = computed(() => {
  if (!$props.modelValue) return []
  return Array.isArray($props.modelValue) ? $props.modelValue : [$props.modelValue]
})
const RolePickerRef = ref()
const formDisabled = useFormDisabled()
const formSize = useFormSize()
const disabled = computed(() => {
  return formDisabled.value || $props.disabled
})
const openRolePicker = () => {
  RolePickerRef.value?.open()
}
const onClose = (id) => {
  if (!$props.modelValue) return
  if ($props.multiple && Array.isArray($props.modelValue)) {
    const newValue = $props.modelValue.filter(s => String(s) !== String(id))
    $emits('update:modelValue', newValue)
  } else {
    $emits('update:modelValue', null)
  }
}
</script>

<template>
  <role-picker ref="RolePickerRef" :multiple="multiple" :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)" />
  <div class="role-wrapper">
    <el-button
      class="role-but-item"
      :size="formSize"
      :disabled="disabled"
      @click="openRolePicker"
      circle
    >
      <el-icon>
        <Avatar />
      </el-icon>
    </el-button>
    <RoleTag
      v-for="item in valueArr"
      :closable="!disabled"
      :key="item"
      :id="item"
      @close="onClose"
    />
    <el-text v-show="!value || value.length === 0" class="placeholder">
      {{ placeholder }}
    </el-text>
  </div>
</template>

<style scoped lang="scss">
.el-tag {
  padding: 0 3px;
}

.role-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 7px;
  gap: 7px;

  .placeholder {
    color: var(--el-text-color-placeholder);
  }

  .role-but-item {
    border-style: dashed;

    &:hover {
      border-style: solid;
    }
  }
}
</style>
